import React, { useContext, useState } from "react";
import { Carousel } from "react-bootstrap";
import { AddToCartButton } from "../../../../../Components/AddToCartComponent";
import { AlertComponent } from "../../../../../Components/AlertComponent";
import { variableProductValidator } from "../../../../../Helpers/validator";
import { Context } from "../../../../../Shared/Context/GlobalContext";
import { StyledImageProduct, StyledTwoColumn } from "../../../style.css";
import { useTranslation } from "react-i18next";
import parse from "html-react-parser";
import { formatCurrency } from "../../../../../Helpers/currency";

export const VariableProductPage = ({
  product,
  setSelectedVariation,
  setShow,
  isModal = false,
}) => {
  const [selectedProduct, setSelectedProduct] = useState({});
  const [error, setError] = useState(null);
  const { cartProducts } = useContext(Context);
  const { t } = useTranslation();

  const variationsList = (
    <div className="row g-2">
      {product.product_variations.map((variation) => {
        let hasStock;
        if (variation.stock === null) {
          hasStock = true;
        } else {
          if (variation.stock > 0) {
            let cartProduct = cartProducts.find(
              (i) => i.product.variation && i.product.variation.id === variation.id
            );
            hasStock = cartProduct
              ? cartProduct.product.quantity < variation.stock
              : true;
          } else {
            hasStock = false;
          }
        }

        return (
          <div className="col-6 col-md-4" key={variation.id}>
            <div
              role="button"
              className={`card border ${!hasStock ? "opacity-50" : ""} ${
                selectedProduct.variation &&
                variation.id === selectedProduct.variation.id
                  ? "border-success border-2"
                  : ""
              }`}
              onClick={() => {
                if (isModal) {
                  if (hasStock) {
                    setSelectedVariation(variation);
                    setShow(false);
                  }
                } else {
                  if (hasStock) {
                    setSelectedProduct({
                      ...product,
                      variation: variation,
                      price: variation.regular_price,
                    });
                  }
                }
              }}
            >
              {variation.images && (
                <img
                  src={variation.images[0].src}
                  alt={variation.name}
                  className="card-img-top"
                  style={{ aspectRatio: "1/1", objectFit: "cover" }}
                />
              )}
              <div className="card-body p-2 text-center">
                <h6 className="card-title small mb-1">
                  {t(variation.name.replace(`${product.name} -`, ""))}
                </h6>
                <small className="text-muted fw-medium">
                  {hasStock
                    ? variation.regular_price > 0
                      ? formatCurrency(variation.regular_price)
                      : t("Seleccionar")
                    : t("Agotado")}
                </small>
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );

  if (isModal) {
    return variationsList;
  }

  return (
    <StyledTwoColumn>
      <div>
        <Carousel data-bs-theme="dark" indicators={product.images.length > 1}>
          {product.images.map((i) => (
            <Carousel.Item key={i.src}>
              <StyledImageProduct src={i.src} className="w-100 d-block" />
            </Carousel.Item>
          ))}
        </Carousel>
      </div>

      <div className="d-flex flex-column">
        <h1 className="h3 fw-bold mb-2">{t(product.name)}</h1>
        <p className="h5 mb-2" style={{ color: "var(--tws-brown)" }}>
          {product.price ? formatCurrency(product.price) : t("Desde ") + formatCurrency(Math.min(...product.product_variations.map(v => parseFloat(v.regular_price))))}
        </p>
        {product.short_description && (
          <div className="mb-3" id="product-desc">
            {parse(t(product.short_description))}
          </div>
        )}

        <h6 className="fw-bold mb-2">{t("Selecciona una opción")}</h6>
        {variationsList}

        {error && (
          <AlertComponent variant="danger" className="mt-3">
            {error}
          </AlertComponent>
        )}
        <div className="mt-3">
          <AddToCartButton
            originalProduct={product}
            product={selectedProduct}
            validator={variableProductValidator}
            setError={setError}
          />
        </div>
      </div>
    </StyledTwoColumn>
  );
};
